(function () {
  function formatBytes(bytes) {
    if (!bytes || bytes <= 0) return '';
    if (bytes >= 1073741824) return (bytes / 1073741824).toFixed(1) + ' GB';
    if (bytes >= 1048576) return (bytes / 1048576).toFixed(1) + ' MB';
    if (bytes >= 1024) return Math.round(bytes / 1024) + ' KB';
    return bytes + ' B';
  }

  function parseSizeValue(text) {
    if (!text) return 0;
    var match = String(text).trim().match(/^([\d.]+)\s*(B|KB|MB|GB)$/i);
    if (!match) return 0;
    var num = parseFloat(match[1]);
    var unit = match[2].toUpperCase();
    if (unit === 'GB') return num * 1073741824;
    if (unit === 'MB') return num * 1048576;
    if (unit === 'KB') return num * 1024;
    return num;
  }

  function initTable(root) {
    var table = root.querySelector('.product-downloads__table');
    if (!table) return;

    var tbody = table.querySelector('tbody');
    var sortButtons = table.querySelectorAll('.product-downloads__sort[data-sort]');

    sortButtons.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var key = btn.getAttribute('data-sort');
        var direction = 'asc';

        if (btn.classList.contains('is-active')) {
          direction = btn.getAttribute('data-direction') === 'asc' ? 'desc' : 'asc';
        }

        sortButtons.forEach(function (other) {
          other.classList.remove('is-active');
          other.removeAttribute('data-direction');
        });

        btn.classList.add('is-active');
        btn.setAttribute('data-direction', direction);

        var rows = Array.from(tbody.querySelectorAll('tr'));
        rows.sort(function (a, b) {
          var aVal = a.getAttribute('data-' + key) || '';
          var bVal = b.getAttribute('data-' + key) || '';

          if (key === 'size') {
            aVal = parseSizeValue(aVal) || parseFloat(a.getAttribute('data-size-bytes') || '0');
            bVal = parseSizeValue(bVal) || parseFloat(b.getAttribute('data-size-bytes') || '0');
            return direction === 'asc' ? aVal - bVal : bVal - aVal;
          }

          if (key === 'release') {
            aVal = a.getAttribute('data-release-ts') || '0';
            bVal = b.getAttribute('data-release-ts') || '0';
            return direction === 'asc'
              ? parseFloat(aVal) - parseFloat(bVal)
              : parseFloat(bVal) - parseFloat(aVal);
          }

          aVal = aVal.toLowerCase();
          bVal = bVal.toLowerCase();
          if (aVal < bVal) return direction === 'asc' ? -1 : 1;
          if (aVal > bVal) return direction === 'asc' ? 1 : -1;
          return 0;
        });

        rows.forEach(function (row) {
          tbody.appendChild(row);
        });
      });
    });

    root.querySelectorAll('[data-fetch-size]').forEach(function (cell) {
      var url = cell.getAttribute('data-fetch-size');
      if (!url || cell.textContent.trim()) return;

      fetch(url, { method: 'HEAD', mode: 'cors' })
        .then(function (res) {
          var len = res.headers.get('Content-Length');
          if (!len) return;
          var formatted = formatBytes(parseInt(len, 10));
          if (!formatted) return;
          cell.textContent = formatted;
          var row = cell.closest('tr');
          if (row) {
            row.setAttribute('data-size', formatted);
            row.setAttribute('data-size-bytes', len);
          }
        })
        .catch(function () {});
    });
  }

  document.querySelectorAll('[data-product-downloads]').forEach(initTable);
})();
